import {FC} from "react";
import CommonAppLayout from "./Common";
import {BarChart2, Building2, Search, MessageCircle} from "lucide-react";

const AdminAppLayout: FC = () => {
  const routes = [
    {
      name: "Stats",
      icon: BarChart2,
      path: "/stats",
    },
    {
      name: "Talent Finder",
      icon: Search,
      path: "/talent",
    },
    {
      name: "BooksMatch Messages",
      icon: MessageCircle,
      path: "/chat",
    },
    {
      name: "Enterprise",
      title: "Enterprise Management",
      icon: Building2,
      path: "/enterprise",
    },
  ];

  return <CommonAppLayout routes={routes} />;
};

export default AdminAppLayout;
